import { Loader2, Pencil, X } from 'lucide-react';
import type { SyntheticEvent } from 'react';
import { cn } from '@/lib/infra/utils';

interface OrderActionButtonsProps {
  disabled?: boolean;
  canceling?: boolean;
  onEdit: () => void;
  onCancel: () => void | Promise<void>;
  className?: string;
}

export function OrderActionButtons({
  disabled = false,
  canceling = false,
  onEdit,
  onCancel,
  className,
}: OrderActionButtonsProps) {
  const stop = (e: SyntheticEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className={cn('inline-flex items-center gap-1', className)}
      onClick={stop}
      onPointerDown={stop}
    >
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onEdit();
        }}
        disabled={disabled || canceling}
        title="Edit price"
        aria-label="Edit price"
        className="text-muted-foreground hover:bg-muted hover:text-foreground inline-flex h-6 w-6 items-center justify-center rounded transition-colors disabled:opacity-50"
      >
        <Pencil size={13} />
      </button>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          void onCancel();
        }}
        disabled={disabled || canceling}
        title="Cancel order"
        aria-label="Cancel order"
        className="text-muted-foreground hover:bg-red-500/10 hover:text-red-400 inline-flex h-6 w-6 items-center justify-center rounded transition-colors disabled:opacity-50"
      >
        {canceling ? <Loader2 size={13} className="animate-spin" /> : <X size={14} />}
      </button>
    </div>
  );
}

export default OrderActionButtons;
